/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
// libraries
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
// utils
import axios from 'axios';
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useAuth } from '../../components/context/Info';
import FavoritosComponent from '../../components/fixed/favoritos/FavoritosComponent';
import WhatsAppComponent from '../../components/fixed/whatsapp/WhatsappComponent';
import WelcomePiecesCompany from '../../components/pieces/welcomeCompany/WelcomePiecesCompany';
import PopUpComponent from '../../components/popUp/PopUpComponent';
import RealEstateSchemaMarkup from '../../components/screma/RealEstateSchemaMarkup';
import { propertiesFilter, propertiesFilterPromocao, propertiesMapa, propertiesMapaPromocao } from '../../services/properties';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados, getCompany } from '../../services/selectors';
import { apenasArray, formatCaracteristicas, formatSelects, formatSelectsTransacao, isColorLight, removerAcentos } from '../../utils/FunctionsGlobals';
import ListPiecesProperties from './components/pieces/list/ListPiecesProperties';
const AboutPieces = dynamic(() => import('../../components/pieces/about/AboutPieces'), { ssr: false });
const AboutPieces1 = dynamic(() => import('../../components/pieces/about1/AboutPieces1'), { ssr: false });
const AboutPieces2 = dynamic(() => import('../../components/pieces/about1/AboutPieces2'), { ssr: false });
// import { getSeverSideList } from '../../utils/ServerSideList';
import { getWithTTL } from '../../utils/storage';
import styles from './Properties.module.css';

// export const getServerSideProps = getSeverSideList;

const Properties = () => {
    // constants
    const {
        allDataHome,
        favorito,
        setFavorito,
        isMobile1,
        init_props,
        setAllCompany,
        allCompany,
        getOnlyQuery1,
        setGetOnlyQuery1,
        setListCategory,
        listCategory,
        listCaracteristicas,
        listDatas,
        listEstados,
        setListDatas,
        setListCaracteristicas,
        setListEstados,
        ultimaConsulta,
        allViewProperties,
        setUltimaConsulta
    } = useAuth();

    const router = useRouter();
    const { pagination } = router.query;
    const { favoritos } = router.query;
    const { utm_source } = router.query;
    const { utm_medium } = router.query;
    const { utm_id } = router.query;
    const { utm_campaign } = router.query;
    const { promocao } = router.query;
    const { min } = router.query;
    const { area_min } = router.query;
    const { area_max } = router.query;
    const { max } = router.query;
    const { banheiros } = router.query;
    const { dormitorios } = router.query;
    const { id_caracteristica } = router.query;
    const { data_entrega } = router.query;
    const { suites } = router.query;
    const { vagas } = router.query;
    const { ordem } = router.query;
    const { codsite } = router.query;
    const { transacao } = router.query;
    const { agenciador } = router.query;
    const categoria: number = router.query.categoria ? +router.query.categoria : 0;
    const id_estado: number = router.query.id_estado ? +router.query.id_estado : 0;
    const asPath = init_props?.asPath || router.asPath;
    const codsite2 = init_props?.codsite;

    const renderOnlyTextFilters1 = () => {
        const resposta = asPath.split("/")
        if(categoryActual?.value){
            return categoryActual?.label
        }
        if(dataEntregaActual?.length > 0){
            return `Imóveis com entrega em ${dataEntregaActual?.map((tip: any) => {return tip?.value}).join(",")}`
        }
        if(promocao){
            return 'Promoções'
        }
        if(resposta[7]){
            return 'por código'
        }
        if(resposta[2] == "venda"){
            return 'à venda'
        }
        if(resposta[2] == "aluguel"){
            return 'para alugar'
        }
        if(resposta[2] == "temporada"){
            return 'para Temporada'
        }
        return 'à venda'
    };

    const renderOrdem = () => {
        const options=[
            {
                label: 'Mais Recentes',
                value: 'desc-inclusao',
            },
            {
                label: 'Mais Antigos',
                value: 'asc-inclusao',
            },
            {
                label: 'Maior Valor',
                value: 'desc-valor',
            },
            {
                label: 'Menor Valor',
                value: 'asc-valor',
            },
            {
                label: 'Mais Visitados',
                value: 'desc-visualizacao',
            },
            {
                label: 'Menos Visitados',
                value: 'asc-visualizacao',
            },
            {
                label: 'Exclusivos',
                value: 'asc-exclusivos',
            },
        ]

        const option = options.find(option => option.value === allDataHome?.site?.ordenar_lista);

        return {
            label: option?.label || "",
            value: allDataHome?.site?.ordenar_lista || "",
        }
    }

    const [newPath, setNewPath] = useState(asPath);
    const getArraysPaths = newPath.split('?')[0].split('/');
    const [initialFlow, setInitialFlow] = useState<any>(['home','imóveis',...getArraysPaths.slice(2, getArraysPaths.length).filter((v: any) => !['asc', 'desc'].includes(v)),]);
    const valores: any = {precos_venda: [allDataHome?.precos_venda[0] || [{min:0,max:1000000}]], precos_locacao: [allDataHome?.precos_locacao[0] || [{min:0,max:100000}]]};
    const [allPropertiesMapa, setAllPropertiesMapa] = useState<any>([]);
    const [allProperties, setAllProperties] = useState<any>([]);

    const site = allDataHome?.site;
    const [typeActual, setTypeActual] = useState<Array<any>>([]);

    const [orderActual, setOrderActual] = useState<any>(ordem != undefined && ordem != site?.ordenar_lista ? 
        {
            label: String(ordem).replace("asc-","Menos ").replace("desc-","Mais ").replace("Inclusao","Recentes").replace("inclusao","Recentes").replace("Menos Exclusivos","Exclusivos"),
            value: String(ordem)
        }
            :
        renderOrdem()
    );
    const bannerListagem = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "listagem");
    const urlBannerListagem = bannerListagem ? bannerListagem.length > 0 ? bannerListagem[0] : null : null;

    const initialValue = {
        suites_min: suites != undefined ? Number(suites) : 0,
        garagems_min: vagas != undefined ? Number(vagas) : 0,
        dormitorios_min: dormitorios != undefined ? Number(dormitorios) : 0,
        banheiros_min: banheiros != undefined ? Number(banheiros) : 0
    };
    const caracteristica = id_caracteristica != undefined ? id_caracteristica : "";
    const datas_entrega = data_entrega != undefined ? data_entrega : "";

    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const [districtActual, setDistrictActual] = useState<Array<any>>([]);
    const [openFavoritos, setOpenFavoritos] = useState<boolean>(favoritos ? true : false)
    const [naoEncontrou, setNaoEncontrou] = useState<boolean>(false)
    const [companyActual, setCompanyActual] = useState<any>(null);
    const [cityActual, setCityActual] = useState<any>(null);
    const [filtersInitialized, setFiltersInitialized] = useState(false);
    const [first, setFirst] = useState(false);
    const [categoryActual, setCategoryActual] = useState<any>(null);
    const [estadoActual, setEstadoActual] = useState<any>(null);
    const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
    const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
    const [codeActual, setCodeActual] = useState('');
    const [type, setType] = useState(asPath.split("/")[2] == "temporada" ? 'temporada' : asPath.split("/")[2] == "aluguel" ? 'rent' : 'sale');
    const [idAgenciador, setAgenciador] = useState<Number>(agenciador ? Number(agenciador) : 0);
    const [typeValidation, setTypeValidation] = useState(renderOnlyTextFilters1());
    const allTransacao = allDataHome?.site?.transacoes ? formatSelectsTransacao(allDataHome?.site?.transacoes) : []
    const cor_detalhes = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13; 

    const newFilter = () => {
        if (type) {
            if (type.toLowerCase() === 'rent') {
                return valores?.precos_locacao[0];
            }
            if (type.toLowerCase() === 'sale') {
                return valores?.precos_venda[0];
            }
        } else {
            if (allTransacao[0]?.value.toLowerCase() === 'aluguel') {
                return valores?.precos_locacao[0];
            }
            if (allTransacao[0]?.value.toLowerCase() === 'venda') {
                return valores?.precos_venda[0];
            }
        }
        if(valores?.precos_venda[0]?.max > 0){
            return valores?.precos_venda[0];
        }else{
            return valores?.precos_locacao[0];
        }
    };
    const getFiltersPricess = newFilter();
    const [filterPrice, setFilterPrice] = useState<any>(min || max ? {min: Number(min) || 0,max: Number(max) || 0} : !getFiltersPricess?.min && !getFiltersPricess?.max ? { min: 0, max: 0 } : getFiltersPricess);
    const [price, setPrice] = useState<Array<number>>(min || max ? [min ? Number(min) : 0,max ? Number(max) : 0] : [getFiltersPricess?.min , getFiltersPricess?.max]);
    const [area, setArea] = useState<Array<any>>(area_min || area_max ? [area_min ? area_min : 0,area_max ? area_max : 0] : [0,0]);
    const [page, setPage] = useState<number>(pagination ? Number(pagination) : 1);
    const [qtd, setQtd] = useState(0);
    const [listDistrict, setListDistrict] = useState<any>([]);
    const listType = allDataHome?.tipos ? formatSelects(allDataHome?.tipos) : [];
    const [companyInputActual, setCompanyInputActual] = useState('');
    const [allUrl, setAllUrl] = useState('');
    const [loading, setLoading] = useState<any>(true);
    const [filters, setFilters] = useState<any>(initialValue);
    const [activeLargeFilter, setActiveLargeFilter] = useState(false);
    const allCities = allDataHome?.cidades ? formatSelects(allDataHome?.cidades,allDataHome?.site?.cidade_priorizada ) : [];
    const [listCity, setListCity] = useState<any>(allCities);
    const codsite1 = init_props?.codsite;
    const origin = init_props?.origemInit;

    useEffect(() => {
        if(Number(max) > 0 && max && max != undefined){
            if(Number(min)>0 && min != undefined){
                setPrice([Number(min),Number(max)])
            }else{
                setPrice([0,Number(max)])
            }
        }
    }, []);

    useEffect(() => {
        if (pagination && Number(pagination) != page) {
            setPage(Number(pagination || 1));
        }
    }, [pagination]);
    // methods
    useEffect(() => {
        if (favorito === null) {
            setOpenFavoritos(false)
        }
    }, [favorito]);

    useEffect(() => {
        if(newPath){
            const getArraysPaths = newPath.split('?')[0].split('/');
            setInitialFlow([
                'home',
                'imóveis',
                ...getArraysPaths
                    .slice(2, getArraysPaths.length)
                    .filter((v: any) => !['asc', 'desc'].includes(v)),
            ]);
        }
    }, [newPath]);

    useEffect(() => {
        if (router.query) {
            const timeOutId = setTimeout(() => {
                GetInitialFilters();
            }, 500);
            return () => clearTimeout(timeOutId);
        }
    }, []);

    const GetInitialFilters2 = async () => {
        if(listCategory == 0 && site?.categoria_home){
            const getCondo: any = JSON.parse(localStorage.getItem('listCategory1') || '[]');

            if(getCondo?.length > 0){
                setListCategory(getCondo);
                if(Number.isInteger(categoria) && categoria > 0){
                    const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === categoria);
                    if(objeto){
                        setCategoryActual(objeto)
                    }
                }
            } else {
                const infoCategory = await categorias(origin, codsite1);
                if(infoCategory){
                    const formatCategorias = await formatSelects(infoCategory?.categorias);
                    if(formatCategorias?.length > 0){
                        if(Number.isInteger(categoria) && categoria > 0){
                            const objeto = formatCategorias.find((item: { label: string; value: number; }) => item.value === categoria);
                            if(objeto){
                                setCategoryActual(objeto)
                            }
                        }
                        localStorage.setItem('listCategory1', JSON.stringify(formatCategorias));
                        setListCategory(formatCategorias);
                    }
                    else
                        setListCategory([]);
                }
                
            }
        } else {
            if(Number.isInteger(categoria) && categoria > 0 && listCategory){
                const getCondo = listCategory || []
                const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === categoria);
                if(objeto){
                    setCategoryActual(objeto)
                }
            }
        }

        if(listEstados == 0 && site?.id == 2177){
            const getCondo: any = JSON.parse(localStorage.getItem('listEstados') || '[]');
   
            if(getCondo?.length > 0){
                setListEstados(getCondo);
                if(Number.isInteger(id_estado) && id_estado > 0){
                    const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === id_estado);
                    if(objeto){
                        setEstadoActual(objeto)
                        if(objeto.value > 0){
                            const cidadesFiltradas = allCities.filter(
                                (city: { id_estado: any; }) => city?.id_estado === objeto.value
                            );
                
                            setListCity(cidadesFiltradas)
                        }
                    }
                }
            } else {
                const infoCategory = await get_estados(origin, codsite1);
                if(infoCategory){
                    const formatCategorias = await formatSelects(infoCategory?.estados);
                    if(formatCategorias?.length > 0){
                        if(Number.isInteger(id_estado) && id_estado > 0){
                            const objeto = formatCategorias.find((item: { label: string; value: number; }) => item.value === id_estado);
                            if(objeto){
                                setEstadoActual(objeto)

                                if(objeto.value > 0){
                                    const cidadesFiltradas = allCities.filter(
                                        (city: { id_estado: any; }) => city?.id_estado === objeto.value
                                    );
                        
                                    setListCity(cidadesFiltradas)
                                }
                            }
                        }
                        localStorage.setItem('listEstados', JSON.stringify(formatCategorias));
                        setListEstados(formatCategorias);
                    } else {
                        setListEstados([]);
                    }
                }
            }
        } else {
            if(Number.isInteger(id_estado) && id_estado > 0 && listEstados){
                const getCondo = listEstados || []
                const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === id_estado);
                if(objeto){
                    setEstadoActual(objeto)
                }
            }
        }

        if(listDatas == 0 && site?.mostrar_data_entrega){
            const getCondo: any = JSON.parse(localStorage.getItem('listDatas') || '[]');

            if(getCondo?.length > 0){
                setListDatas(getCondo);
                if(datas_entrega){
                    const DatasArray = String(datas_entrega)
                        ?.split(',')                       // Dividir a string por vírgula
                        .map(str => str.trim())             // Remover espaços extras
                        .map(Number)                        // Converter cada item para número
                        .filter(num => !isNaN(num));        // Filtrar valores que não são números
                    const GetOnlyDatas = getCondo?.filter((e: any) => {
                        return DatasArray.includes(e.value);
                    });

                    setDataEntregaActual(GetOnlyDatas ? GetOnlyDatas : []);
                }
            } else {
                const infoDatas = await allDatasEntrega(origin, codsite1);
                const formatDatas = await formatSelectsTransacao(infoDatas?.datas_entrega);
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                formatDatas.unshift(newItem);
                if(formatDatas?.length > 0){
                    if(datas_entrega){
                        const DatasArray = String(datas_entrega)
                            ?.split(',')                       // Dividir a string por vírgula
                            .map(str => str.trim())             // Remover espaços extras
                            .map(Number)                        // Converter cada item para número
                            .filter(num => !isNaN(num));        // Filtrar valores que não são números

                        // Passo 2: Filtrar o array 'getCondo' usando os valores do array de características
                        const GetOnlyDatas = formatDatas?.filter((e: any) => {
                            return DatasArray.includes(e.value);
                        });

                        setDataEntregaActual(GetOnlyDatas ? GetOnlyDatas : []);
                    }
                    localStorage.setItem('listDatas', JSON.stringify(formatDatas));
                }
                else
                    setListDatas([]);
            }
        } else {
            if(datas_entrega && listDatas){
                const getCondo: any = listDatas || []
                const DatasArray = String(datas_entrega)
                    ?.split(',')                       // Dividir a string por vírgula
                    .map(str => str.trim())             // Remover espaços extras
                    .map(Number)                        // Converter cada item para número
                    .filter(num => !isNaN(num));        // Filtrar valores que não são números
                const GetOnlyDatas = getCondo?.filter((e: any) => {
                    return DatasArray.includes(e.value);
                });

                setDataEntregaActual(GetOnlyDatas ? GetOnlyDatas : []);
            }
        }

        if(listCaracteristicas == 0 && site?.caracteristicas_home){
            const getCondo: any = JSON.parse(localStorage.getItem('listCaracteristicas') || '[]');

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
                if(caracteristica){
                    const caracteristicasArray = String(caracteristica)
                        ?.split(',')                       // Dividir a string por vírgula
                        .map(str => str.trim())             // Remover espaços extras
                        .map(Number)                        // Converter cada item para número
                        .filter(num => !isNaN(num));        // Filtrar valores que não são números

                    const GetOnlyCar = getCondo?.filter((e: any) => {
                        return caracteristicasArray.includes(e.value);
                    });

                    setCaractActual(GetOnlyCar ? GetOnlyCar : []);
                }
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite1);
                const formatCarac = await formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);

                    if(caracteristica){
                        const caracteristicasArray = String(caracteristica)
                            ?.split(',')                       // Dividir a string por vírgula
                            .map(str => str.trim())             // Remover espaços extras
                            .map(Number)                        // Converter cada item para número
                            .filter(num => !isNaN(num));        // Filtrar valores que não são números

                        // Passo 2: Filtrar o array 'getCondo' usando os valores do array de características
                        const GetOnlyCar = formatCarac?.filter((e: any) => {
                            return caracteristicasArray.includes(e.value);
                        });

                        setCaractActual(GetOnlyCar ? GetOnlyCar : []);
                    }
                    localStorage.setItem('listCaracteristicas', JSON.stringify(formatCarac));
                }
                else
                setListCaracteristicas([]);
            }
        } else {
            if(caracteristica && listCaracteristicas){
                const getCaract: any = listCaracteristicas || []
                const caracteristicasArray = String(caracteristica)
                    ?.split(',')                       // Dividir a string por vírgula
                    .map(str => str.trim())             // Remover espaços extras
                    .map(Number)                        // Converter cada item para número
                    .filter(num => !isNaN(num));        // Filtrar valores que não são números

                const GetOnlyCar = getCaract?.filter((e: any) => {
                    return caracteristicasArray.includes(e.value);
                });

                setCaractActual(GetOnlyCar ? GetOnlyCar : []);
            }
        }
    }

    useEffect(() => {
        if(site?.caracteristicas_home || site?.categoria_home || site?.mostrar_data_entrega || site?.id == 2177){
            GetInitialFilters2()
        }
    }, []);

    const GetInitialFilters = async () => {
        let formatType = listType;
        let formatCities = allCities;

        if(site?.id == 2177){
            if(id_estado > 0){
                const cidadesFiltradas = allCities.filter(
                    (city: { id_estado: number; }) => city?.id_estado === id_estado
                );
    
                setListCity(cidadesFiltradas)
            } else {
                if(estadoActual?.value){
                    const cidadesFiltradas = allCities.filter(
                        (city: { id_estado: any; }) => city?.id_estado === estadoActual?.value
                    );
        
                    setListCity(cidadesFiltradas)
                } else {
                    setListCity(allCities);
                }
            }
        }

        let GetOnlyType = null;
        let getCity: any = null;
        let getDistrict = null;
        // let GetOnlyCompany = null;
        const query_type = router.query?.type != '[type]' ? router.query?.type || '-' : '-'
        const query_city = router.query?.city != '[city]' ? router.query?.city || '-' : '-'
        const query_district = router.query?.district != '[district]' ? router.query?.district || '-' : '-'
        const query_company = router.query?.company != '[company]' ? router.query?.company : '-'
        const query_transacao = router.query?.model == 'venda' || router.query?.model == 'aluguel' || router.query?.model == 'temporada' ? router.query?.model : 'venda'

        if (query_type && query_type != "-") {
            GetOnlyType = formatType?.filter((e: any) => {
                return removerAcentos(String(query_type)).toLowerCase()?.replaceAll('---', '-002D-')
                    ?.replaceAll('-', ' ')
                    ?.replaceAll('002D', '-')
                    ?.replaceAll('002d', '-')
                    ?.replaceAll("\n", '-')
                    ?.split('+')
                    ?.includes(removerAcentos(e.label).toLowerCase());
            });
            setTypeActual(GetOnlyType ? GetOnlyType : []);
        }

        if (query_city && query_city != "-") {
            getCity = formatCities.find(
                (v: any) =>
                    removerAcentos(String(v.label)).toLowerCase() ===
                    removerAcentos(String(query_city)).toLowerCase()
                        ?.replaceAll('-', ' ')
                        ?.replaceAll('002D', '-')
                        ?.replaceAll('002d', '-')
                        ?.replaceAll("\n", '-')
            );
            if(getCity){
                setCityActual(getCity);
                const infoDistrict = await district(Number(getCity?.value || -1), origin, codsite1);
                if(infoDistrict){
                    const formatListDistrict = formatSelects(infoDistrict?.bairros);
                    setListDistrict(formatListDistrict);
                    if(query_district && query_district != "-"){
                        getDistrict = formatListDistrict.filter((v: any) => {
                            return removerAcentos(String(query_district)).toLowerCase()
                                ?.replaceAll('-', ' ')
                                ?.replaceAll('002D', '-')
                                ?.replaceAll('002d', '-')
                                ?.replaceAll("\n", '-')
                                ?.split('+')
                                ?.includes(removerAcentos(v.label).toLowerCase());
                        });
                        setDistrictActual(getDistrict ? getDistrict : []);
                    }
                }
            }
        }
        if (query_company && query_company != '-') {
            // Fazer request pegando aquele nome do condominio
            const companyFormat = removerAcentos(String(query_company)).toLowerCase()?.replaceAll('-',' ')?.replaceAll('002D', '-')?.replaceAll('002d', '-')?.replaceAll("\n", '-');
            const infoCompany: any = await getCompany(companyFormat, origin, codsite1);

            if (infoCompany?.empreendimentos?.length) {
                const formatCompany = await formatSelects(
                    infoCompany?.empreendimentos
                );
                // Pegar o primeiro elemento caso tenham dois com o mesmo nome
                if (formatCompany?.length > 0) {
                    setCompanyActual({
                        label: formatCompany[0]?.label,
                        value: formatCompany[0]?.value,
                    });
                } else {
                    setCompanyActual(0);
                }
            } else {
                setCompanyActual(0);
            }
        } else {
            setCompanyActual(0);
        }

        if (router.query?.code) {
            setCodeActual(String(router.query?.code).replaceAll("%20"," "));
        }
        if(transacao != undefined && transacao && site?.transacoes){
            setType(JSON.stringify(transacao))
        }else{
            if (query_transacao === 'aluguel') {
                setType('rent');
            } else {
                if(query_transacao === 'venda'){
                    setType('sale');
                } else {
                    setType('temporada');
                }
            }
        }
        setFiltersInitialized(true)
    };

    const zeraFiltros = () => {
        setPage(1)
        setCityActual(null)
        setTypeActual([])
        setCaractActual([])
        setDistrictActual([])
        setType("sale")
        setFilters([])
        setAgenciador(0)
        setPrice([filterPrice?.min,filterPrice?.max]);
        setCompanyActual(0)
        setCategoryActual(null)
        setDataEntregaActual([])
        setFiltersInitialized(true)
    }

    const GetInitial = async (newPage?: boolean) => {
        const verifyPage = () => {
            if (page) {
                return page;
            }
            return 1;
        };

        const query_type = router.query?.type != '[type]' ? router.query?.type || '-' : '-'
        const query_city = router.query?.city != '[city]' ? router.query?.city || '-' : '-'
        const query_district = router.query?.district != '[district]' ? router.query?.district || '-' : '-'
        const query_company = router.query?.company != '[company]' ? router.query?.company : '-'
        const pageActual = verifyPage();
        let buscou = 0;

        const trans = type == "sale" ? "venda" : type == "rent" ? "aluguel" : type == "temporada" ? "temporada" : router.query?.model == 'venda' || router.query?.model == 'aluguel' || router.query?.model == 'temporada' ? router.query?.model : 'venda';
        let newPathForm = `/imoveis/${trans}/${
            cityActual?.label?.replaceAll('-', '002D')?.replaceAll(' ', '-')?.replaceAll("\n", '-') || '-'
        }/${
            districtActual
                ?.map((e) => e?.label?.replaceAll('-', '002D')?.replaceAll(' ', '-')?.replaceAll("\n", '-'))
                ?.join()
                ?.replaceAll(',', '+') || '-'
        }/${
            companyActual?.label
                ? companyActual?.label?.replaceAll('-', '002D')?.replaceAll(' ', '-')?.replaceAll("\n", '-')
                : '-'
        }/${
            typeActual
                ?.map((e) => e?.label?.replaceAll('-', '002D')?.replaceAll(' ', '-')?.replaceAll("\n", '-'))
                ?.join()
                ?.replaceAll(',', '+') || '-'
        }${
            codeActual ? `/${codeActual?.replaceAll(' ', '%20')}` : ''
        }`?.replaceAll(' ', '');
        
        if (!window.location.pathname.includes('/novidades')) {
            if(removerAcentos(newPathForm).toLowerCase() != newPath)
                setNewPath(removerAcentos(newPathForm).toLowerCase());

            if(categoryActual?.value || caractActual?.length > 0 || dataEntregaActual?.length > 0 || codsite || id_estado > 0 || categoria > 0 || area[0] || area[1] || price[0] || price[1] || utm_source || utm_medium || utm_id || utm_campaign || filters.suites_min || filters.dormitorios_min || filters.garagems_min || filters.banheiros_min || openFavoritos || promocao == "1"){
                newPathForm = newPathForm+'?filtros'
                if(price[0] || price[1]){
                    newPathForm = newPathForm+'&min='+price[0]+'&max='+price[1]
                }
                if(area[0] || area[1]){
                    newPathForm = newPathForm+'&area_min='+area[0]+'&area_max='+area[1]
                }
                if(categoryActual?.value){
                    newPathForm = newPathForm+'&categoria='+categoryActual?.value
                } else {
                    if(categoria > 0){
                        newPathForm = newPathForm+'&categoria='+categoria
                    }
                }
                if(estadoActual?.value){
                    newPathForm = newPathForm+'&id_estado='+estadoActual?.value
                } else {
                    if(id_estado > 0){
                        newPathForm = newPathForm+'&id_estado='+id_estado
                    }
                }
                if(dataEntregaActual?.length > 0){
                    newPathForm = newPathForm + '&data_entrega='+dataEntregaActual?.map((tip: any) => {return tip?.value}).join(",");
                } else {
                    if(datas_entrega){
                        newPathForm = newPathForm+'&data_entrega='+datas_entrega
                    }
                }
                if(codsite){
                    newPathForm = newPathForm+'&codsite='+codsite
                }
                if(promocao){
                    newPathForm = newPathForm+'&promocao=1'
                }
                if(utm_source){
                    newPathForm = newPathForm+'&utm_source='+utm_source
                }
                if(utm_medium){
                    newPathForm = newPathForm+'&utm_medium='+utm_medium
                }
                if(utm_id){
                    newPathForm = newPathForm+'&utm_id='+utm_id
                }
                if(utm_campaign){
                    newPathForm = newPathForm+'&utm_campaign='+utm_campaign
                }
                if(filters.suites_min){
                    newPathForm = newPathForm+'&suites='+filters.suites_min
                }
                if(filters.dormitorios_min){
                    newPathForm = newPathForm+'&dormitorios='+filters.dormitorios_min
                }
                if(filters.garagems_min){
                    newPathForm = newPathForm+'&vagas='+filters.garagems_min
                }
                if(filters.banheiros_min){
                    newPathForm = newPathForm+'&banheiros='+filters.banheiros_min
                }
                if(orderActual?.value){
                    newPathForm = newPathForm+'&ordem='+orderActual?.value
                }
                if(pageActual){
                    newPathForm = newPathForm+'&pagination='+pageActual
                }
                if(caractActual?.length > 0){
                    newPathForm = newPathForm + '&id_caracteristica='+caractActual?.map((tip: any) => {return tip?.value}).join(",");
                } else {
                    if(caracteristica){
                        newPathForm = newPathForm+'&id_caracteristica='+caracteristica
                    }
                }

                if((favorito?.length > 0 || favoritos) && openFavoritos){
                    newPathForm = newPathForm+'&favoritos='+JSON.stringify(favorito).replaceAll("[","").replaceAll("]","")
                }
            }
        }

        if((ultimaConsulta == "" || newPathForm != ultimaConsulta || first || allProperties?.length == 0) && filterPrice?.max > 0 && ((companyActual?.value || query_company == "-" || query_company == undefined) &&
        (typeActual?.length > 0 || query_type == '-' || query_type == undefined) &&
        (cityActual?.value > 0 || query_city == '-' || query_city == undefined) &&
        (districtActual.length > 0 || query_district == '-' || query_district == undefined) || filtersInitialized)) {
            if(!filtersInitialized)
                setFiltersInitialized(true)

            setFirst(true)

            if(newPathForm != ultimaConsulta)
                setUltimaConsulta(newPathForm)

            let GetFilters
            let getOnlyQuery

            if(ultimaConsulta == newPathForm && getOnlyQuery1?.imoveis?.length > 0){
                GetFilters = getOnlyQuery1
                setAllProperties(getOnlyQuery1?.imoveis)
                getOnlyQuery = getOnlyQuery1;
                setLoading(false);
            } else {
                const getImo = getWithTTL<any>(`ultima_consulta:${newPathForm}`);
                if(getImo?.imoveis?.length > 0){
                    setAllProperties(getImo?.imoveis)
                    GetFilters = getImo
                    getOnlyQuery = getImo;
                    setLoading(false);
                } else {
                    if(promocao == "1"){
                        GetFilters = await propertiesFilterPromocao(
                            categoryActual?.value ? categoryActual?.value : 0,
                            pageActual,
                            cityActual?.value,
                            districtActual.length > 0
                                ? JSON.stringify(districtActual.map((v) => v?.value))
                                : null,
                            typeActual.length > 0
                                ? JSON.stringify(typeActual.map((v) => v?.value))
                                : null,
                            JSON.stringify(codeActual),
                            type == 'sale'
                                ? Number(price[0])
                                : 0,
                            type == 'sale'
                                ? Number(price[1])
                                : null,
                            type == 'rent'
                                ? Number(price[0])
                                : 0,
                            type == 'rent'
                                ? Number(price[1])
                                : null,
                            type == 'sale' ? 1 : 0,
                            type == 'rent' ? 1 : 0,
                            companyActual?.value,
                            orderActual,
                            Number(filters.garagems_min || 0),
                            Number(filters.dormitorios_min || 0),
                            Number(filters.suites_min || 0),
                            Number(filters.banheiros_min || 0),
                            idAgenciador,
                            type == 'temporada'
                                ? Number(price[0])
                                : 0,
                            type == 'temporada'
                                ? Number(price[1])
                                : null,
                            type == 'temporada' ? 1 : 0,
                            openFavoritos ? apenasArray(favorito) : '',
                            origin,
                            codsite1
                        );

                        getOnlyQuery = ['Valor', 'Valor'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_promocao
                        : ['Visualizacao', 'Visualizacao'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_promocao
                        : GetFilters?.imoveis_promocao;
                        setLoading(false);
                    } else {
                        GetFilters = await propertiesFilter(
                            categoryActual?.value ? categoryActual?.value : 0,
                            pageActual,
                            cityActual?.value,
                            districtActual.length > 0
                                ? JSON.stringify(districtActual.map((v) => v?.value))
                                : null,
                            typeActual.length > 0
                                ? JSON.stringify(typeActual.map((v) => v?.value))
                                : null,
                            JSON.stringify(codeActual),
                            type === 'sale'
                                ? Number(price[0])
                                : 0,
                            type === 'sale'
                                ? Number(price[1])
                                : null,
                            type === 'rent'
                                ? Number(price[0])
                                : 0,
                            type === 'rent'
                                ? Number(price[1])
                                : null,
                            type === 'sale' ? 1 : 0,
                            type === 'rent' ? 1 : 0,
                            companyActual?.value,
                            orderActual,
                            Number(filters.garagems_min || 0),
                            Number(filters.dormitorios_min || 0),
                            Number(filters.suites_min || 0),
                            Number(filters.banheiros_min || 0),
                            idAgenciador,
                            type === 'temporada'
                                ? Number(price[0])
                                : 0,
                            type === 'temporada'
                                ? Number(price[1])
                                : null,
                            type === 'temporada' ? 1 : 0,
                            openFavoritos ? apenasArray(favorito) : '',
                            origin,
                            codsite1,
                            caractActual.length > 0
                            ? JSON.stringify(caractActual.map((v) => v?.value))
                            : 0,
                            area[0] >= 0 ? area[0] : 0,
                            area[1] > 0 ? area[1] : 0,
                            0,
                            dataEntregaActual.length > 0
                            ? JSON.stringify(dataEntregaActual.map((v) => v?.value))
                            : 0,
                            estadoActual?.value > 0
                            ? estadoActual?.value
                            : 0
                        );

                        getOnlyQuery = ['Valor', 'Valor'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_busca
                        : ['Visualizacao', 'Visualizacao'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_busca
                        : GetFilters?.imoveis_busca;
                        setLoading(false);
                    }
                }
            }

            router.push(removerAcentos(newPathForm).toLowerCase(), undefined, { shallow: true });
            setAllUrl(removerAcentos(newPathForm).toLowerCase());
          
            setGetOnlyQuery1(getOnlyQuery)
            if (getOnlyQuery?.imoveis?.length > 0) {
                buscou =1;
                setAllProperties(getOnlyQuery?.imoveis);
                setQtd(getOnlyQuery?.count);
                if (typeValidation) {
                    if(codeActual?.length >= 2) {
                        if(typeValidation != 'por código'){
                            setTypeValidation('por código');
                        }
                    }else{
                        if (type === 'sale') {
                            if(typeValidation != 'à venda'){
                                setTypeValidation('à venda');
                            }
                        }
                        if (type === 'rent') {
                            if(typeValidation != 'para alugar'){
                                setTypeValidation('para alugar');
                            }
                        }
                        if (type === 'temporada') {
                            if(typeValidation != 'para Temporada'){
                                setTypeValidation('para Temporada');
                            }
                        }
                    }
                } else {
                    if(typeValidation != renderOnlyTextFilters1()){
                        setTypeValidation(renderOnlyTextFilters1());
                    }
                }
            } else {
                setNaoEncontrou(true)
                setQtd(0)
                setLoading(true)
                setAllProperties([])
                setAllPropertiesMapa([])
            }
        } else {
            setAllProperties([]);
            setAllPropertiesMapa([])
            setQtd(0);

            if(codeActual?.length >= 2) {
                if(typeValidation != 'por código'){
                    setTypeValidation('por código');
                }
            }else{
                if (type === 'sale') {
                    if(typeValidation != 'à venda'){
                        setTypeValidation('à venda');
                    }
                }
                if (type === 'rent') {
                    if(typeValidation != 'para alugar'){
                        setTypeValidation('para alugar');
                    }
                }
                if (type === 'temporada') {
                    if(typeValidation != 'para Temporada'){
                        setTypeValidation('para Temporada');
                    }
                }
            }

            if (newPage && typeof newPage === 'boolean' && page > 1) {
                setPage(page - 1);
                // alert('Não há mais imóveis nas próximas páginas');
            }
        }
        if(site?.mostrar_mapa && site?.mostrar_mapa != undefined && buscou == 1) {
            let GetPropertiesMap
            if(promocao == "1"){
                GetPropertiesMap = await propertiesMapaPromocao(
                    categoryActual?.value ? categoryActual?.value : 0,
                    1,
                    cityActual?.value,
                    districtActual.length > 0
                        ? JSON.stringify(districtActual.map((v) => v?.value))
                        : null,
                    typeActual.length > 0
                        ? JSON.stringify(typeActual.map((v) => v?.value))
                        : null,
                    JSON.stringify(codeActual),
                    type === 'sale'
                        ? Number(price[0])
                        : 0,
                    type === 'sale'
                        ? Number(price[1])
                        : null,
                    type === 'rent'
                        ? Number(price[0])
                        : 0,
                    type === 'rent'
                        ? Number(price[1])
                        : null,
                    type === 'sale' ? 1 : 0,
                    type === 'rent' ? 1 : 0,
                    companyActual?.value,
                    orderActual,
                    Number(filters.garagems_min || 0),
                    Number(filters.dormitorios_min || 0),
                    Number(filters.suites_min || 0),
                    Number(filters.banheiros_min || 0),
                    idAgenciador,
                    type === 'temporada' ? 1 : 0,
                    100,
                    origin,
                    codsite1
                );

                if(GetPropertiesMap?.imoveis_promocao?.count > 0){
                    setAllPropertiesMapa(GetPropertiesMap?.imoveis_promocao?.imoveis)
                }
            } else {
                GetPropertiesMap = await propertiesMapa(
                    categoryActual?.value ? categoryActual?.value : 0,
                    1,
                    cityActual?.value,
                    districtActual.length > 0
                        ? JSON.stringify(districtActual.map((v) => v?.value))
                        : null,
                    typeActual.length > 0
                        ? JSON.stringify(typeActual.map((v) => v?.value))
                        : null,
                    JSON.stringify(codeActual),
                    type === 'sale'
                        ? Number(price[0])
                        : 0,
                    type === 'sale'
                        ? Number(price[1])
                        : null,
                    type === 'rent'
                        ? Number(price[0])
                        : 0,
                    type === 'rent'
                        ? Number(price[1])
                        : null,
                    type === 'sale' ? 1 : 0,
                    type === 'rent' ? 1 : 0,
                    companyActual?.value,
                    orderActual,
                    Number(filters.garagems_min || 0),
                    Number(filters.dormitorios_min || 0),
                    Number(filters.suites_min || 0),
                    Number(filters.banheiros_min || 0),
                    idAgenciador,
                    type === 'temporada' ? 1 : 0,
                    100,
                    origin,
                    codsite1
                );

                if(GetPropertiesMap?.imoveis?.count > 0){
                    setAllPropertiesMapa(GetPropertiesMap?.imoveis?.imoveis)
                }
            }
        }
    };

    const applyFilter = () => {
        setLoading(true);
        if(filtersInitialized){
            GetInitial();
        }
        setActiveLargeFilter(false);
    };

    const GetAllCompany = async () => {
        if(allCompany?.length == 0) {
            const infoCompany = await getCompany("", origin, codsite1);
            setAllCompany([
                { label: '', value: null },
                ...formatSelects(infoCompany?.empreendimentos),
            ]);
            localStorage.setItem('condominios', JSON.stringify(infoCompany));
        }
    };

    const concatLabels = (value: Array<any>) => {
        if (value?.length === 1) {
            return `${value[0]?.label}`;
        }
        if (value?.length === 2) {
            return `${value[0]?.label} e ${value[1]?.label}`;
        }
        if (value?.length >= 3) {
            return `${value[0]?.label}, ${value[1]?.label} e ${value[2]?.label}`;
        }
        return '';
    };

    const renderTextFilters = () => {
        let aux = ""
        if(filters.dormitorios_min && filters.dormitorios_min != undefined){
            if(filters.dormitorios_min == "1")
                aux = " com 1 dormitório"
            else 
                aux = ` com ${filters.dormitorios_min} dormitórios`
        } else {
            if(filters.suites_min && filters.suites_min != undefined){
                if(filters.suites_min == "1")
                    aux = " com 1 suíte"
                else 
                    aux = ` com ${filters.suites_min} suítes`
            } else {
                if(filters.banheiros_min && filters.banheiros_min != undefined){
                    if(filters.banheiros_min == "1")
                        aux = " com 1 banheiro"
                    else 
                        aux = ` com ${filters.banheiros_min} banheiros`
                } else {
                    if(filters.garagems_min && filters.garagems_min != undefined){
                        if(filters.garagems_min == "1")
                            aux = " com 1 vaga"
                        else 
                            aux = ` com ${filters.garagems_min} vagas`
                    }
                }
            } 
        }
        if(promocao == "1"){
            if(allProperties?.length == 0){
                return (
                    <h1 className={styles.qtd} style={{color: cor_detalhes}}>{`Imóveis em Promoção`}</h1>
                );
            }

            return (
                <h1 className={styles.qtd} style={{color: cor_detalhes}}>{`${
                    qtd
                } Imóveis em Promoção`}</h1>
            );
        }
        if(openFavoritos){
            return (
                <h1 className={styles.qtd} style={{color: cor_detalhes}}>{`${
                    favorito?.length
                } ${favorito?.length > 1 ? 'Imóveis Favoritos' : 'imóvel Favorito'}`}</h1>
            );
        }
        if (companyActual) {
            return (
                <>
                    <h1 className={styles.qtd} style={{color: cor_detalhes}}>{`${companyActual?.label} ${cityActual?.label ? `em ${cityActual?.label}` : ''}`}{aux}</h1>
                    <h2 className={styles.qtd1} style={{color: cor_detalhes}}>
                        {`${qtd || 0} ${qtd > 1 ? 'Encontrados' : 'Encontrado'}`}
                    </h2>
                </>
            );
        }
        if (typeValidation && !loading) {
            return (
                <>
                <h1 className={styles.qtd} style={{color: cor_detalhes}}>
                    {`${
                        site?.id != 2034
                        ?   typeActual?.length > 0
                            ?   qtd > 1
                                ?   concatLabels(typeActual)
                                    .replaceAll("Casa", "Casas")
                                    .replaceAll("Terreno", "Terrenos")
                                    .replaceAll("Apartamento", "Apartamentos")
                                    .replaceAll("Sobrado", "Sobrados")
                                    .replaceAll("Cobertura", "Coberturas")
                                :   concatLabels(typeActual)
                            : qtd > 1
                                ?   'Imóveis'
                                :   'Imóvel'
                        :   typeActual?.length > 0
                            ?   concatLabels(typeActual)
                            :   qtd > 1
                                ? 'Imóveis'
                                : 'Imóvel'
                    } ${categoryActual?.value ? categoryActual?.label : ''} ${typeValidation} ${
                        districtActual?.length > 0 ? concatLabels(districtActual) : ''
                    } ${cityActual?.label ? `em ${cityActual?.label}` : ''}`}{aux}
                </h1>
                <h2 className={styles.qtd1} style={{color: cor_detalhes}}>
                    {`${site?.id != 1990 ? (qtd || 0) : ''} ${qtd > 1 ? 'Encontrados' : 'Encontrado'}`}
                </h2>
              </>
            );
        }
        if (!typeValidation && !loading) {
            return (
                <>
                    <h1 className={styles.qtd} style={{color: cor_detalhes}}>Empreendimentos{aux}</h1>
                    <h2 className={styles.qtd1} style={{color: cor_detalhes}}>
                        {`${qtd || ""} ${qtd > 1 ? 'Encontrados' : 'Encontrado'}`}
                    </h2>
                </>
            );
        }
        return null;
    };

    const capitalizeFirstLetter = (text: string) => {
        if (!text) return text;
        return text.charAt(0).toUpperCase() + text.slice(1);
      };

    const renderOnlyTextFilters = () => {
        let aux = ""
        if(dormitorios && dormitorios != undefined){
            if(dormitorios == "1")
                aux = " com 1 dormitório"
            else 
                aux = ` com ${dormitorios} dormitórios`
        } else {
            if(suites && suites != undefined){
                if(suites == "1")
                    aux = " com 1 suíte"
                else 
                    aux = ` com ${suites} suítes`
            } else {
                if(banheiros && banheiros != undefined){
                    if(banheiros == "1")
                        aux = " com 1 banheiro"
                    else 
                        aux = ` com ${banheiros} banheiros`
                } else {
                    if(vagas && vagas != undefined){
                        if(vagas == "1")
                            aux = " com 1 vaga"
                        else 
                            aux = ` com ${vagas} vagas`
                    }
                }
            } 
        }
        const resposta = asPath.split("/")
        if(resposta[7]){
            return `Imóvel cod: ${resposta[7]}`
        }
        if(resposta[5] && resposta[5] != "-"){
            return `${decodeURIComponent(resposta[5].replaceAll("-"," "))} ${resposta[3] && resposta[3] != "-" ? ` em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}` : ""}${aux}`
        }

        let resposta_tipo = []
        if(resposta[6])
            resposta_tipo = resposta[6].split("?")
        if(resposta_tipo[0] != "-" && resposta_tipo[0]){
            if(resposta[3] && resposta[3] != "-"){
                if(resposta[2] == "venda"){
                    return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} à venda em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                } else {
                    if(resposta[2] == "aluguel"){
                        return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para alugar em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                    }
                    if(resposta[2] == "temporada"){
                        return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para temporada em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                    }
                    return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} em ${site?.Dados.cidade ? decodeURIComponent(site?.Dados.cidade) : allCities[0]?.label}${aux}`
                }
            }
            return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para ${resposta[2]}${aux}`
        }
        if(resposta[3] && resposta[3] != "-"){
            if(resposta[2] == "venda"){
                return `Imóveis à venda em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
            } else {
                if(resposta[2] == "aluguel"){
                    return `Imóveis para alugar em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                }
                if(resposta[2] == "temporada"){
                    return `Imóveis para temporada em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                }
                return `Imóveis em ${site?.Dados.cidade ? decodeURIComponent(site?.Dados.cidade) : allCities[0]?.label}${aux}`
            }
        }
        return `Imóveis para ${resposta[2] ? resposta[2] : 'venda'}${aux}`
    };

    // useEffect
    useEffect(() => {
        if(agenciador){
            setAgenciador(Number(agenciador));
        }
        setLoading(true);
        if(banheiros || dormitorios || vagas || suites) {
            setFilters({'suites_min': Number(suites) || 0, 'garagems_min': Number(vagas) || 0, 'dormitorios_min': Number(dormitorios) || 0, 'banheiros_min': Number(banheiros) || 0})
        }
    }, []);

    const registerSearch = async (searchParams = {}) => {
        if (site?.fb_token_pixel && site?.fb_id_pixel){
            let clientIpAddress = '';
            try {
                const res6 = await axios.get('https://api6.ipify.org?format=json');
                clientIpAddress = res6.data.ip;
            } catch {
                const res4 = await axios.get('https://api.ipify.org?format=json');
                clientIpAddress = res4.data.ip;
            }

            const accessToken = site.fb_token_pixel;
            const pixelId = site.fb_id_pixel;
            const eventTime = Math.floor(Date.now() / 1000);

            // lê cookies _fbc e _fbp
            const getCookie = (name: any) =>
                document.cookie
                .split('; ')
                .find((row) => row.startsWith(name + '='))
                ?.split('=')[1] || '';

            const fbc = getCookie('_fbc');
            const fbp = getCookie('_fbp');

            const eventData = [
                {
                    event_name: 'Search', // <- aqui é o evento de busca
                    event_time: eventTime,
                    action_source: 'website',
                    event_source_url: window.location.href,
                    user_data: {
                        client_ip_address: clientIpAddress,
                        fbc,
                        fbp,
                    },
                    custom_data: {
                        // Inclua aqui os filtros utilizados pelo usuário:
                        ...searchParams // Ex: {categoria, cidade, preco_min, preco_max}
                    }
                }
            ];

            try {
                const fbRes = await axios.post(
                    `https://graph.facebook.com/v12.0/${pixelId}/events`,
                    { data: eventData },
                    { params: { access_token: accessToken } }
                );
                console.log('Evento Search registrado com sucesso:', fbRes.data);
            } catch (err) {
                console.error('Erro ao registrar evento Search:', err);
            }
        }
    };

    function debounce<F extends (...args: any[]) => void>(fn: F, delay: number) {
        let timer: ReturnType<typeof setTimeout> | null = null;
        return (...args: Parameters<F>) => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    }

     const renderRodape = () => {
        switch (site?.rodape) {
            case 1:
                return (
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                    </motion.div>
                );
            case 2:
                return (
                    <AboutPieces allRodape={allDataHome?.rodape} site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1}/>
                );
            case 3:
                return (
                    <AboutPieces2 site={site} allRodape={allDataHome?.rodape}/>
                );
            default:
            return (
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                </motion.div>
            );
        }
    }

    const debouncedGetInitial = useCallback(
        debounce(() => {
            setNaoEncontrou(false);
            setLoading(true);
            GetInitial();
            registerSearch({
                content_category: renderOnlyTextFilters() || 'Busca de imóveis',
                currency: 'BRL',
                search_string: router.query?.city || "-",
                property_type: router.query?.type || "-",
                city: router.query?.city || "-",
                neighborhood: router.query?.district || "-"
            });
        }, 400),[cityActual, districtActual, categoryActual, dataEntregaActual, typeActual,
        caractActual, companyActual, codeActual, type, price, orderActual, estadoActual,
        filters, filterPrice, idAgenciador, openFavoritos, area, page]
    );

    useEffect(() => {
        if(filtersInitialized){
            debouncedGetInitial();
        }
    }, [
        cityActual, districtActual, categoryActual, dataEntregaActual, typeActual,
        caractActual, companyActual, codeActual, type, price, orderActual, estadoActual,
        filters, filterPrice, idAgenciador, openFavoritos, area, page
    ]);

    useEffect(() => {
        if(companyInputActual && allCompany?.length == 0){
            const timeOutId = setTimeout(() => {
                const getCondo: any = JSON.parse(localStorage.getItem('condominios') || '[]');
                if (getCondo?.length > 0) {
                    setAllCompany([
                        { label: '', value: null },
                        ...(formatSelects(getCondo) || []),
                    ]);
                } else {
                    GetAllCompany();
                }
            }, 1000);
            return () => clearTimeout(timeOutId);
        }
    }, [companyInputActual]);

    return (
        <div className={styles.container} style={{background: site?.cor5}}>
            <Head>
                <title>{renderOnlyTextFilters() ? capitalizeFirstLetter(renderOnlyTextFilters()) : site?.titulo}</title>
                {allProperties?.length > 0 && init_props?.prodOrigin ?
                    <RealEstateSchemaMarkup url={`https://${init_props?.prodOrigin}${asPath}`} imoveis={allProperties} tipo={'card'}/>
                : null}
            </Head>
            <PopUpComponent site={site}/>
            <WhatsAppComponent site={site} />
            { favorito?.length > 0 ?
                <FavoritosComponent site={site} favorito={favorito} setAuxiliar={setFiltersInitialized} compartilhar={openFavoritos} setOpenFavoritos={setOpenFavoritos} zeraFiltros={zeraFiltros}/>
            : null }
            <WelcomePiecesCompany
                site={site}
                routes={initialFlow}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito}
                bannerListagem={urlBannerListagem}
                props={init_props}
            />
            <ListPiecesProperties
                allProperties={allProperties}
                setAllProperties={setAllProperties}
                site={site}
                page={page}
                area={area}
                allViewProperties={allViewProperties}
                setArea={setArea}
                setPage={setPage}
                searchList={GetInitial}
                qtd={qtd}
                filtersInitialized={filtersInitialized}
                typeValidation={typeValidation}
                typeActual={typeActual}
                setTypeActual={setTypeActual}
                districtActual={districtActual}
                setDistrictActual={setDistrictActual}
                companyActual={companyActual}
                setCompanyActual={setCompanyActual}
                cityActual={cityActual}
                setCityActual={setCityActual}
                codeActual={codeActual}
                setCodeActual={setCodeActual}
                orderActual={orderActual}
                setOrderActual={setOrderActual}
                price={price}
                setPrice={setPrice}
                filterPrice={filterPrice}
                setFilterPrice={setFilterPrice}
                listCity={listCity}
                listType={listType}
                listCompany={allCompany}
                categoryActual={categoryActual}
                setCategoryActual={setCategoryActual}
                setEstadoActual={setEstadoActual}
                estadoActual={estadoActual}
                listEstados={listEstados}
                allCities={allCities}
                setListCity={setListCity}
                listCategory={listCategory}
                listDatas={listDatas}
                dataEntregaActual={dataEntregaActual}
                setDataEntregaActual={setDataEntregaActual}
                listCaract={listCaracteristicas}
                caractActual={caractActual}
                setCaractActual={setCaractActual}
                type={type}
                setType={setType}
                listDistrict={listDistrict}
                setListDistrict={setListDistrict}
                filters={filters}
                setFilters={setFilters}
                applyFilter={applyFilter}
                activeLargeFilter={activeLargeFilter}
                setActiveLargeFilter={setActiveLargeFilter}
                companyInputActual={companyInputActual}
                setCompanyInputActual={setCompanyInputActual}
                loading={loading}
                setLoading={setLoading}
                renderTextFilters={renderTextFilters}
                agenciador={idAgenciador}
                setAgenciador={setAgenciador}
                allPropertiesMapa={allPropertiesMapa}
                favorito={favorito || []}
                openFavoritos={openFavoritos}
                setOpenFavoritos={setOpenFavoritos}
                naoEncontrou={naoEncontrou}
                setFavorito={setFavorito}
                allUrl={allUrl}
                origin={origin}
                codsite={codsite1}
                codsite2={codsite}
                valores={valores}
            />
            { renderRodape() }
        </div>
    );
};

export default Properties;
